import {
  PROPOSAL_REVIEW_STATUS,
  PRODUCT_ATTR_DISPLAY_MODE,
  PRODUCT_WARRANTY_PERIOD_NONE,
  PRE_ORDER_EXPECTED_SHIP_DATE
} from '@vzmi/shp_shared_compo/constants/proposal'
/** proposal constants for Redux form */
import { getDefaultTimezoneMoment } from '../../../lib/renderUtil'
import { getDefaultListingOffShelvedTs } from '../../lib/FormHelper'
import { TOAST_DURATION, PROPOSAL_PHASE_TYPE } from '../../constants/proposalTypes'
import { unbindBeforeunload } from './Common/BeforeUnload'
import errorHelper from '../../../lib/errorHelper'
import { Toast } from '@vzmi/shp_shared_compo'
import _ from 'lodash'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'

/**
 * 審核期限
 * 預設日期：今日+15天
 * 日期後方顯示提醒文字：給本公司的審核天數不得少於提案日+3天，最多可設定提案日+15天
 */
const currentMoment = getDefaultTimezoneMoment()
const currentMomentBaseDate = currentMoment
  .clone()
  .set({ hour: 0, minute: 0, second: 0 })
const deadlineDefaultDate = currentMomentBaseDate
  .clone()
  .add(15, 'day')
  .format()
export const DEADLINE_OPTIONS = {
  defaultDate: deadlineDefaultDate,
  minDate: currentMomentBaseDate
    .clone()
    .add(3, 'day')
    .format(),
  maxDate: deadlineDefaultDate
}

/**
 * 預定出貨日
 * 供應商特殊功能檔有提供"預購商品"功能：預購日期不可小於今日+5，不可大於今日+180
 * 若僅提案子站有提供"預購商品"功能，維持現行：預購日期不可小於今日+5，不可大於今日+45
 */
const expectedShipDateDefaultDate = currentMomentBaseDate.clone().add(5, 'day')
export const PRE_ORDER_EXPECTED_SHIP_DATE_OPTIONS = {
  placeholder: expectedShipDateDefaultDate.format('YYYY/MM/DD'),
  minDate: expectedShipDateDefaultDate.format(),
  maxDate: currentMoment
    .clone()
    .add(PRE_ORDER_EXPECTED_SHIP_DATE.SUB_STATION_MAX_DATE, 'day')
    .format()
}

export const PRE_ORDER_EXPECTED_SHIP_DATE_SUPPLIER_OPTIONS = {
  placeholder: expectedShipDateDefaultDate.format('YYYY/MM/DD'),
  minDate: expectedShipDateDefaultDate.format(),
  maxDate: currentMoment
    .clone()
    .add(PRE_ORDER_EXPECTED_SHIP_DATE.SUPPLIER_MAX_DATE, 'day')
    .format()
}

// FIRST_SECTION_OFFSET 第一個Section加anchor section以及Header的距離
// SECTION_OFFSET： 每個Section以及sticky anchor section之距離
export const COMPOSE_SECTION_OFFSET = {
  SECTION_OFFSET: -190,
  FIRST_SECTION_OFFSET: -160
}

export const MAIN_AND_REVIEW_IMAGE_COUNT = 2
export const IMAGE_UPLOADER_MAX_FILE = 10
export const IMAGE_UPLOADER_RECOMMENDED_IMAGE_WIDTH_SIZE = 1000
export const IMAGE_UPLOADER_RECOMMENDED_IMAGE_HEIGHT_SIZE = 1000
export const IMAGE_UPLOADER_MIN_IMAGE_HEIGHT_SIZE = 400
export const IMAGE_UPLOADER_MIN_IMAGE_WIDTH_SIZE = 400

export const TRANSIENT_FIELD_KEY = '__transient__'
export const INVALID_TRANSIENT_KEY = 'INVALID_TRANSIENT_KEY'
export const SHIP_TYPE_FORM_SECTION_NAME = 'shipTypeFormSection'

// 開始時間預設值
export const ON_SHELVED_TS_OPTIONS = {
  defaultDate: currentMoment
    .clone()
    .set({ second: 0, millisecond: 0 })
    .format(),
  minDate: currentMoment
    .clone()
    .set({ second: 0, millisecond: 0 })
    .subtract(90, 'days')
    .format(),
  maxDate: currentMoment
    .clone()
    .set({ second: 0, millisecond: 0 })
    .add(10, 'years')
    .format()
}

export const getWarrantyFields = rootField => {
  const warrantyPeriodField = `${rootField}.period`
  const warrantyScopeField = `${rootField}.scope`
  const warrantyCustomScopeField = `${rootField}.custom_scope`
  const warrantyHandlerField = `${rootField}.handler`
  const warrantyDescField = `${rootField}.description`
  const warrantyStatusField = `${rootField}.productStatus`
  return {
    warrantyPeriodField,
    warrantyScopeField,
    warrantyCustomScopeField,
    warrantyHandlerField,
    warrantyDescField,
    warrantyStatusField
  }
}

export const WARRANTY_FIELD = 'product.warranty'
const {
  warrantyPeriodField,
  warrantyScopeField,
  warrantyCustomScopeField,
  warrantyHandlerField,
  warrantyDescField,
  warrantyStatusField
} = getWarrantyFields(WARRANTY_FIELD)
export const WARRANTY_PERIOD_FIELD = warrantyPeriodField
export const WARRANTY_SCOPE_FIELD = warrantyScopeField
export const WARRANTY_CUSTOM_SCOPE_FIELD = warrantyCustomScopeField
export const WARRANTY_HANDLER_FIELD = warrantyHandlerField
export const WARRANTY_DESC_FIELD = warrantyDescField
export const WARRANTY_STATUS_FIELD = warrantyStatusField
export const LISTING_IS_THRESHOLD_FREEBIE = 'listing.isThresholdFreebie'
// DEFAULT_FORM_DATA 會在 submit proposal 時拿來取預設欄位
export const DEFAULT_FORM_DATA = {
  initiallyFetchedListing: null,
  [TRANSIENT_FIELD_KEY]: null,
  [SHIP_TYPE_FORM_SECTION_NAME]: null,
  modifier: null,
  creator: null,
  reviewStatus: PROPOSAL_REVIEW_STATUS.COMPOSING,
  mustShowFormError: false,
  setting: {},
  subStationId: null,
  subStationLabel: null,
  applicant: null,
  id: null,
  type: null,
  expiredTs: DEADLINE_OPTIONS.defaultDate,
  note: null,
  product: {
    id: null,
    name: null,
    catId: null,
    catItemId: null,
    struDataAttrClusterId: null,
    shipType: { id: null },
    copy: null,
    contentRating: null,
    msrp: null,
    cost: null,
    safeStockQty: '1',
    models: [
      {
        videos: []
      }
    ],
    warranty: {
      period: PRODUCT_WARRANTY_PERIOD_NONE,
      scope: null,
      handler: null,
      description: null,
      productStatus: 'new'
    },
    partNo: null,
    brand: null,
    brandId: null,
    brandName: null,
    model: null,
    gameContents: [],
    isNeedRecycle: false,
    attributeDisplayMode: PRODUCT_ATTR_DISPLAY_MODE.TABLE,
    shortDescription: [],
    taxable: true,
    taxFree: false
  },
  listing: {
    onShelvedTs: ON_SHELVED_TS_OPTIONS.defaultDate,
    offShelvedTs: getDefaultListingOffShelvedTs(
      ON_SHELVED_TS_OPTIONS.defaultDate
    ),
    isDisplay: true,
    price: null,
    purchaseQtyLimit: '12',
    cvsPurchaseQtyLimit: '1',
    featureTitle: null,
    isThresholdFreebie: false
  },
  executeStatus: null,
  executeResult: null,
  declineReason: null,
  declineDetail: null,
  suggestion: null,
  executedTs: null
}

/**
 * TODO: transform this function to Proposal's method
 */
export const isEditableReviewStatus = reviewStatus => _.includes([
  PROPOSAL_REVIEW_STATUS.COMPOSING,
  PROPOSAL_REVIEW_STATUS.DRAFT
], reviewStatus)

export const checkEditableProposal = reviewStatus => {
  const isEditableProposal = isEditableReviewStatus(reviewStatus)
  if (!isEditableProposal) {
    Toast.error(
      '提案單狀態不允許編輯，僅供檢視',
      { duration: TOAST_DURATION }
    )
    const currentUrl = window.location.href
    const overviewUrl = currentUrl.replace(
      RegExp(`${PROPOSAL_PHASE_TYPE.COMPOSE}`),
      `${PROPOSAL_PHASE_TYPE.OVERVIEW}`
    )

    // 不允許編輯之提案單，跳轉檢視頁及不回傳提案資訊
    unbindBeforeunload()
    errorHelper.redirect({ url: overviewUrl })
  }

  return isEditableProposal
}

export const redirectToProposalFeature = (
  invokeRedirect,
  feature,
  phase,
  id
) => {
  unbindBeforeunload()

  Toast.error('重新導向至正確頁面', { duration: TOAST_DURATION })

  const { origin } = document.location
  const proposalId = id
    ? `?id=${id}`
    : ''

  invokeRedirect({ url: `${origin}/proposal/${feature}/${phase}${proposalId}` })
}

export const getContactWindow = (user) => {
  const contactWindow = _.flow(
    () => _.get(user, 'yContactWindows', []),
    contactWindows => _.map(contactWindows, ({ name, email }) => `${name}(${email})`),
    contactStrings => _.join(contactStrings, `${COMMA} `)
  )()
  return contactWindow
}
